import { useMediaQuery } from '@vueuse/core';
import { computed, reactive } from 'vue';
import { SCREEN_MEDIUM } from '@/config';

export type ScreenMode = 'mobile' | 'desktop';

export type ScreenModeState = Record<ScreenMode, boolean>;

export default function useScreenModes(): ScreenModeState {
  const isDesktop = useMediaQuery(`(min-width: ${SCREEN_MEDIUM}px)`);
  const isMobile = computed(() => !isDesktop.value);

  return reactive({
    mobile: isMobile,
    desktop: isDesktop,
  });
}
